import type { RoleRouteConfig } from '@/router';
import { measureDetailRoutes } from './measureDetailRoutes';
import {
  MANUFACTURING_PROCESS_ROUTE_NAME,
  RENEWABLE_ENERGY_ROUTE_NAME,
  TECH_MEASURES_WITH_TYPE_ROUTE_NAME,
  TECH_MEASURE_DETAIL_ROUTE_NAME,
  TECH_MEASURES_ROUTE
} from '@/data/routes';
import { t } from '@/locales/i18n';

export const batstoolRoutes: Array<RoleRouteConfig> = [
  {
    path: '/manufacturing-process',
    name: MANUFACTURING_PROCESS_ROUTE_NAME,
    component: () => import('@/views/ManufacturingProcessSelection'),
    meta: {
      title: t('home.manufacturingProcessSelection')
    }
  },
  {
    path: '/tech-measures/:manufacturing/:type?',
    name: TECH_MEASURES_WITH_TYPE_ROUTE_NAME,
    component: () => import('@/views/TechMeasures'),
    meta: {
      title: t('home.techMeasuresTab')
    },
    props: true
  },
  {
    path: '/tech-measures',
    name: TECH_MEASURES_ROUTE,
    component: () => import('@/views/TechMeasures'),
    meta: {
      title: t('home.techMeasuresTab')
    },
    props: true
  },
  {
    path: '/tech-measures/:manufacturing/:type/:measure',
    name: TECH_MEASURE_DETAIL_ROUTE_NAME,
    component: () => import('@/views/TechMeasureDetail'),
    meta: {
      title: t('home.techMeasureDetail')
    },
    props: true,
    children: [...measureDetailRoutes]
  },
  {
    path: '/renewable-energy',
    name: RENEWABLE_ENERGY_ROUTE_NAME,
    component: () => import('@/views/RenewableEnergy'),
    meta: {
      title: t('home.renewableEnergyTab')
    }
  }
];
